<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      v-if="brokerLogo"
      class="mx-auto mt-8 hidden h-11 w-auto md:block"
      :src="brokerLogo"
      alt="broker logo"
    />
    <img
      v-if="brokerLogo"
      class="mx-auto h-11 w-auto md:hidden"
      :src="brokerLogo"
      alt="broker logo"
    />
  </div>
  <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
  <layout>
    <h3 class="my-8 mt-10 text-left text-3xl text-dark-gray">Verification</h3>
    <p class="my-2 text-left text-dark-gray">
      {{ subtitle }}
    </p>
    <div
      class="mb-3 flex flex-row gap-2 rounded-lg border border-pumpkin-400 bg-pumpkin-100 p-2 text-left"
    >
      <div>
        <svg
          class="h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.2699 3.82273C9.03875 2.49138 10.9612 2.49138 11.7294 3.82273L16.6254 12.3087C17.3936 13.64 16.4324 15.3042 14.8953 15.3042H5.10397C3.56693 15.3042 2.60637 13.64 3.37455 12.3087L8.26923 3.82273H8.2699ZM9.99998 7.3155C10.1324 7.3155 10.2594 7.3681 10.353 7.46173C10.4466 7.55536 10.4992 7.68234 10.4992 7.81475V10.311C10.4992 10.4434 10.4466 10.5704 10.353 10.664C10.2594 10.7577 10.1324 10.8103 9.99998 10.8103C9.86757 10.8103 9.74058 10.7577 9.64695 10.664C9.55332 10.5704 9.50072 10.4434 9.50072 10.311V7.81475C9.50072 7.68234 9.55332 7.55536 9.64695 7.46173C9.74058 7.3681 9.86757 7.3155 9.99998 7.3155ZM9.99998 12.8073C10.1324 12.8073 10.2594 12.7547 10.353 12.6611C10.4466 12.5674 10.4992 12.4404 10.4992 12.308C10.4992 12.1756 10.4466 12.0486 10.353 11.955C10.2594 11.8614 10.1324 11.8088 9.99998 11.8088C9.86757 11.8088 9.74058 11.8614 9.64695 11.955C9.55332 12.0486 9.50072 12.1756 9.50072 12.308C9.50072 12.4404 9.55332 12.5674 9.64695 12.6611C9.74058 12.7547 9.86757 12.8073 9.99998 12.8073Z"
            fill="#FF9330"
          />
        </svg>
      </div>
      <p class="text-xs font-normal text-pumpkin-900">
        Highway will never call you for your verification code. Please do not
        share with anyone that asks for your code.
      </p>
    </div>
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <form-field
        id="login-verification"
        label="Verification Code"
        :value="verification_code"
        placeholder="Enter Verification Code"
        :on-input="onInput"
        name="verification_code"
        maxlength="6"
        :is-valid="!error"
        error-message="Incorrect verification code"
      />
      <button-main
        class="my-3 mb-4"
        :disabled="!isValidCode"
        type="submit"
        :loading-spinner="isLoading"
        value="Continue"
      />
    </form>

    <div class="mt-4 flex flex-col items-center">
      <p class="mb-2 text-body-color">Didn't get a code?</p>
      <router-link
        :to="loginPath"
        class="mx-auto w-max text-yellow-500"
      >
        Try again
      </router-link>
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex';

import Layout from '@/components/LoginLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'LoginVerification',
  components: {
    Layout,
    ButtonMain,
    FormField,
  },
  props: {
    goBack: Function,
  },
  data() {
    return {
      isEmailRequiredForLogin: this.$route.query?.fromEmail || false,
      isLoading: false,
      error: false,
      verification_code: '',
    };
  },
  async created() {
    await this.$store.dispatch(
      'brokers/getLogoByClientId',
      localStorage.getItem('client_id')
    );
  },
  computed: {
    ...mapState({
      brokerLogo: (state) => state.brokers?.logo?.url || null,
      currentUser: (state) => state.users?.currentUser || {},
    }),
    isValidCode() {
      return this.verification_code && this.verification_code.length === 6;
    },
    subtitle() {
      let source = 'mobile number';
      if (this.isEmailRequiredForLogin) source = 'email address';
      return ` Please enter the code we just sent to the ${source} number you entered.`;
    },
    loginPath() {
      return this.isEmailRequiredForLogin ? '/login-with-email' : '/login';
    },
  },
  mounted() {
    const find = document.querySelector('#login-verification');
    find.focus();
  },
  methods: {
    onInput(e) {
      this.verification_code = e.target.value;
    },
    async handleSubmit() {
      this.isLoading = true;
      const res = await this.$store.dispatch('users/postSignInCode', {
        code: this.verification_code,
      });

      // The endpoint is called to know the value of the property: is_email_required_for_login
      await this.$store.dispatch('users/serverRefreshCurrentUser');

      if ([200, 201].includes(res.status)) {
        // Carrier validation code success
        // Send user to user details step
        this.validation_error = false;
        let redirectAfterSignIn = JSON.parse(
          localStorage.getItem('redirect_url_after_sigin')
        );

        // If they came in through the OAuth process,
        // then then they will be redirected to the /oauth/authorizations
        // endpoint with the correct credentials
        if (redirectAfterSignIn) {
          localStorage.removeItem('redirect_url_after_sigin');
          return this.$router.push(redirectAfterSignIn);
        } else {
          let companyType =
            this.$store.state.users.currentUser.company.company_type;

          switch (companyType) {
            case 'broker':
              return this.$router.push({ name: 'Broker Dashboard' });
            case 'carrier':
              return this.$router.push({ name: 'CarrierWelcomePage' });
            case 'dispatcher':
              return this.$router.push({ name: 'Dispatcher Dashboard' });
            default:
              return this.$router.push({ name: 'Home' });
          }
        }
      } else {
        this.validation_error = true;
        toastResponse(this, res, null);
      }
      this.isLoading = false;
    },
  },
};
</script>
